export class TransactionFlowChartConstants {
  public static ELEMENT_SELECTOR = 'svg#transaction-flow-chart';
  public static LINK_LINE_STROKE = 2;
  public static MARKER_REF = 'end';
  public static SVG_WIDTH = 450;
  public static SVG_HEIGHT = 300;

  public static MODAL_ELEMENT_SELECTOR = 'svg#transaction-flow-modal-chart';
  public static MODAL_LINK_LINE_STROKE = 1;
  public static MODAL_MARKER_REF = 'end-line';
  public static MODAL_SVG_HEIGHT = 350;
}
